// Devuelve solo el primer nombre (sin apellidos) a partir del nombre completo.
export const firstName = (full) => {
  if (!full) return '';
  return String(full).trim().split(/\s+/)[0] || '';
};

export default firstName;
